module.exports = __webpack_public_path__ + "static/media/battery.46eae16c.svg";